import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

export type SystemVersionDto = {
  version: string;
};

@Injectable({ providedIn: 'root' })
export class SystemApiService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  getVersion() {
    return this.http.get<SystemVersionDto>(`${this.baseUrl}/system/version`);
  }
}
